import classNames from 'classnames';
import Text from 'components/Text/Text';
import React from 'react';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import style from './UseCustomerSettingsCheckBox.module.scss';

interface IUseCustomerSettingsCheckBox {
	isUseCustomerSettings: boolean;
}

const UseCustomerSettingsCheckBox: React.FC<IUseCustomerSettingsCheckBox> = ({ isUseCustomerSettings }) => {
	const iconClasses = classNames(style.icon, { [isUseCustomerSettings ? style.iconDone : style.iconClose]: true });

	return (
		<div className={style.container}>
			<svg className={iconClasses}>
				<use xlinkHref={`${breadcrumbs}#${isUseCustomerSettings ? 'done' : 'close'}`} />
			</svg>
			<Text translationNameSpace="mediaSettings" translationKey="useCustomerSettingsLabel" asFragment={true} />
		</div>
	);
};

export default UseCustomerSettingsCheckBox;
